// Browser fingerprinting utility — generates a semi-stable device ID from browser characteristics
// This is NOT cryptographic — it's a best-effort identifier for "is this the same browser?"

export async function generateFingerprint() {
    const components = []

    // Screen properties
    components.push(`${screen.width}x${screen.height}x${screen.colorDepth}`)
    components.push(window.devicePixelRatio || 1)

    // Timezone
    components.push(Intl.DateTimeFormat().resolvedOptions().timeZone)

    // Language
    components.push(navigator.language)

    // Platform
    components.push(navigator.platform || navigator.userAgentData?.platform || 'unknown')

    // Hardware concurrency
    components.push(navigator.hardwareConcurrency || 0)

    // Device memory (Chrome only)
    components.push(navigator.deviceMemory || 0)

    // Touch support
    components.push(navigator.maxTouchPoints || 0)

    // Canvas fingerprint (draws text and extracts a hash)
    try {
        const canvas = document.createElement('canvas')
        canvas.width = 200
        canvas.height = 50
        const ctx = canvas.getContext('2d')
        ctx.textBaseline = 'alphabetic'
        ctx.font = '14px Arial'
        ctx.fillStyle = '#f60'
        ctx.fillRect(0, 0, 62, 20)
        ctx.fillStyle = '#069'
        ctx.fillText('BaraquBot FP', 2, 15)
        ctx.fillStyle = 'rgba(102,204,0,0.7)'
        ctx.fillText('BaraquBot FP', 4, 17)
        components.push(canvas.toDataURL().slice(-50))
    } catch {
        components.push('no-canvas')
    }

    // WebGL renderer (GPU identifier)
    try {
        const canvas = document.createElement('canvas')
        const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
        if (gl) {
            const debugInfo = gl.getExtension('WEBGL_debug_renderer_info')
            if (debugInfo) {
                components.push(gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL))
            }
        }
    } catch {
        components.push('no-webgl')
    }

    // Hash all components
    const raw = components.join('|')
    const encoder = new TextEncoder()
    const data = encoder.encode(raw)

    if (crypto.subtle) {
        const hashBuffer = await crypto.subtle.digest('SHA-256', data)
        const hashArray = Array.from(new Uint8Array(hashBuffer))
        return hashArray.map(b => b.toString(16).padStart(2, '0')).join('').substring(0, 32)
    }

    // Fallback: simple hash
    let hash = 0
    for (let i = 0; i < raw.length; i++) {
        const char = raw.charCodeAt(i)
        hash = ((hash << 5) - hash) + char
        hash |= 0
    }
    return Math.abs(hash).toString(16).padStart(8, '0')
}
